import React from 'react';
import DeviceEventEmitter, { EventName } from '../../control/event';
import { Container, Typography, Redirect, withStyles } from '../../material-ui';

import MRedux from '../view/MRedux';

import BgImage from '../../images/login/launch.jpg';
import MStatusBar from '../view/MStatusBar';
import AppUtils from '../../control/apputlis';


class LoadingPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            adsTimes: 0,
        };
    }

    componentDidMount() {
        AppUtils.setStorageItem(AppUtils.MATCH_SELECT_TIMER, 0);
        MRedux.clearAllState();
        this._checkEnterScene();
        AppUtils.YMPush('LOADING', 'loading界面');
    }

    componentWillUnmount() {
        clearInterval(this.adsInterval);
    }

    _checkEnterScene = () => {
        // 显示广告
        DeviceEventEmitter.emit(EventName.LOAD_COMPLETE);
        this.setState({ isShowAd: true });
        this.adsInterval = setInterval(() => {
            let times = this.state.adsTimes;
            times--;
            this.setState({ adsTimes: times });
            if (this.state.adsTimes <= 0) {
                clearInterval(this.adsInterval);
            }
        }, 1000);
    }

    render() {
        const { classes } = this.props;
        const { adsTimes } = this.state;
        return (
            adsTimes <= 0 ? <Redirect to="/" />
                : <React.Fragment >
                    <Container style={{
                        backgroundPositionX: 'center',
                        backgroundPositionY: 'center',
                        backgroundImage: `url(${BgImage})`,
                        backgroundSize: 'cover',
                        width: '100vw',
                        height: '100vh',
                    }}>
                        <div></div>
                    </Container>
                    <Container style={{ width: '100%', position: 'absolute', top: 20 }}>
                        <MStatusBar />
                        <Container className={classes.root}>
                            <Typography style={{ position: 'absolute', color: '#ffffff', fontSize: 20 }}>{adsTimes}</Typography>
                        </Container>
                    </Container>
                </React.Fragment >
        )
    }
}

export default withStyles((theme) => ({
    root: {
        backgroundColor: 'rgba(115,109,127,0.3)',
        borderRadius: 15,
        width: 30,
        height: 30,
        right: 20,
        position: 'absolute',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center'
    },
}))(LoadingPage);